export default "__VITE_ASSET__202424ff__"